export default __webpack_public_path__ + "static/media/fatherClosed.fb827608.jpg";